// zero-based index of box sides in CSS box model
const boxSide = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3,
};

export { boxSide };
//# sourceMappingURL=constants.js.map
